/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="95.58"
        height="98.32"
        viewBox="0 0 95.58 98.32"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="M81.5 3a1.26 1.26 0 0 1 1.24 1.13v73.63A1.25 1.25 0 0 1 81.62 79H62.5a1.252 1.252 0 0 1-.13-2.5H80.3v-71H69.84v9.83a1.25 1.25 0 0 1-1.12 1.24h-.13a1.25 1.25 0 0 1-1.24-1.13V4.2A1.25 1.25 0 0 1 68.5 3h13ZM14.11 23.51a1.24 1.24 0 0 1 1.24 1.12v51.83h17.8a1.26 1.26 0 0 1 1.25 1.12v.13A1.25 1.25 0 0 1 33.28 79H14.11a1.24 1.24 0 0 1-1.24-1.13V24.76a1.25 1.25 0 0 1 1.24-1.25Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M47.08.22a1.24 1.24 0 0 1 1.3-.07l.12.07 46.54 31.87a1.25 1.25 0 0 1-1.3 2.13l-.11-.07L47.79 2.76 1.96 34.15a1.26 1.26 0 0 1-1.66-.22l-.08-.1a1.25 1.25 0 0 1 .22-1.66l.1-.08Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M52.28 48.35h1c4.34 0 7.64.41 9.2 4.08a.35.35 0 0 0 .32.21.35.35 0 0 0 .34-.35v-.07c-1.25-5.15-2.13-10.13-15.64-10.13-1.92 0-2.53 0-3.57 1.22s-1.44 1-1.44 1h-2.4a.49.49 0 0 1-.49-.49.9.9 0 0 0-.91-.9h-3.64a.9.9 0 0 0-.91.9V50a.91.91 0 0 0 .91.91h3.62a.91.91 0 0 0 .91-.91.49.49 0 0 1 .49-.49H43c2.47 0 2.67 3.13 2.67 3.13v11.75h4.21V51.48c0-1.72 1.07-3.12 2.4-3.12"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#ffb81c"
          d="M49.84 63.54a4.17 4.17 0 0 1 2.2 2.73 3.26 3.26 0 0 1 .12 1.07v26.71a4.39 4.39 0 0 1-8.78 0V67.34a3.26 3.26 0 0 1 .12-1.07 4.17 4.17 0 0 1 2.2-2.73Z"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
      </svg>

    );
  }
}

Icon.displayName = 'HouseWithHammerIcon';

export default Icon;
